export default {"src":"/_next/static/media/archaeology.b092cb96.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};